import React from "react";
import Navbar from "../../../../src/component/Navbar";

function PrivacyPolicy() {
  return (
    <>
      <div className="pt-28 pb-8 bg-gray-50 min-h-screen">
        <Navbar homePage={false} />
        <div className="max-w-4xl mx-auto p-8">
          <div className="bg-white p-8 rounded-xl shadow-md">
            <h1 className="text-3xl font-bold uppercase mb-6">
              Privacy Policy
            </h1>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">1. Introduction</h3>
              <p className="text-gray-700 leading-relaxed">
                This Privacy Policy explains how NOTAM.ae (“we”, “our”, or “us”) collects, uses, and protects your information when you access or interact with our website. We are committed to respecting your privacy and ensuring the protection of your personal data.
              </p>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">2. Information We Collect</h3>
              <p className="text-gray-700 leading-relaxed">
                <strong>a. Information You Provide:</strong> Name, email, username, password, and NOTAM-related content you upload.
              </p>
              <p className="text-gray-700 leading-relaxed">
                When registering or contacting us, you may provide:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Name and email address</li>
                <li>Username and password</li>
                <li>Any NOTAM-related content or comments you upload</li>
              </ul>

              <p className="text-gray-700 leading-relaxed">
                <strong>b. Automatically Collected Data:</strong>
              </p>
              <p className="text-gray-700 leading-relaxed">
                When you visit the Website, we may collect:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>IP address</li>
                <li>Browser type/version</li>
                <li>Date and time of access</li>
                <li>Referring pages or links</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                This data is used strictly for analytics and technical improvements.
              </p>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">3. How We Use Your Information</h3>
              <p className="text-gray-700 leading-relaxed"> 
                We use your data to manage accounts, provide access to NOTAM tools, allow uploading/viewing of content, respond to inquiries, and improve website functionality and security.
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>To manage your user account</li>
                <li>To provide access to our NOTAM visualization tools</li>
                <li>To allow uploading, viewing, and sharing of NOTAM content</li>
                <li>To respond to inquiries or support requests</li>
                <li>To improve the Website’s functionality and security</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                We do not use your data for marketing purposes, and we do not sell your personal information.
              </p>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">4. Cookies and Tracking Technologies</h3>
              <p className="text-gray-700 leading-relaxed">
                We may use cookies or similar technologies to:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Remember your preferences or login session</li>
                <li>Collect anonymous traffic and usage analytics</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                You can modify your browser settings to disable cookies, though some features may not function properly.
              </p>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">5. Sharing of Data</h3>
              <p className="text-gray-700 leading-relaxed">
                We do not sell, rent, or share your personal information with third parties, except:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>When required by law or legal obligation</li>
                <li>To protect the rights and safety of the Website or other users</li>
              </ul>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">6. User-Generated Content</h3>
              <p className="text-gray-700 leading-relaxed">                                                                                                                                                               
                Content you voluntarily upload (e.g. NOTAM entries, comments) may be visible to other users. Please avoid posting sensitive personal data.
              </p>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">7. Data Security</h3>
              <p className="text-gray-700 leading-relaxed">
                We implement reasonable technical and organizational measures to secure your data. However, no online system is completely immune to risk. You are responsible for safeguarding your own account credentials.
              </p>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">8. Third-Party Links</h3>
              <p className="text-gray-700 leading-relaxed">
                The Website may contain links to external websites or services. This Privacy Policy does not apply to third-party sites. We are not responsible for their content or privacy practices.
              </p>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">9. Your Rights</h3>
              <p className="text-gray-700 leading-relaxed">
                Depending on your jurisdiction, you may have rights to:
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Access the personal data we hold about you</li>
                <li>Correct or update your data</li>
                <li>Request correction or deletion</li>
                <li>Withdraw consent where applicable</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                To exercise these rights, contact us at{" "}
                <a href="mailto:notamsinfo@gmail.com" className="text-blue-600 hover:underline">
                  notamsinfo@gmail.com
                </a>
              </p>
            </section>

            <section className="mb-6">
              <h3 className="text-2xl font-semibold mb-2">10. Changes to This Policy</h3>
              <p className="text-gray-700 leading-relaxed">
                We may update this Privacy Policy periodically. Changes will be posted on this page with a revised “Effective Date.” Continued use of the Website indicates your acceptance of the updated policy.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
}

export default PrivacyPolicy;
